<template>
    <div class="container-fluid" >
        <headerApp :title="this.translate('promotionsTitle')"></headerApp>
        <div class="row">
            <div class="col-xs-24">
                <div class="col-container">
                    <div class="form" v-if="activeTarjetas.length" v-lang.explicacionBeneficios></div>
                    <div v-for="item in activeTarjetas" class="promotion-item" v-bind:key="item.uuid">
                        <div class="form">
                            <img :src="profilePic(item)" alt="" class="logo-anunciante">
                            <h3 class="text-center">{{ item.promocion.anunciante.name }}</h3>
                            <div class="text-center">
                                {{ item.promocion.anunciante.address }}
                                <br />
                                <small>{{ item.promocion.anunciante.phone }}</small>
                            </div>
                            <div class="text-center" v-if="item.promocion.discount">
                                <div class=" discount-offer">
                                    {{ item.promocion.discount }}%
                                </div>
                            </div>
                            <div class="text-center lead no-mb" v-if="item.promocion.promotion">{{ item.promocion.promotion }}</div>
                            <div class="text-center lead" v-if="item.promocion.products">
                                <span v-lang.en></span>:
                                {{ item.promocion.products }}
                            </div>
                            <div class="text-center" v-if="item.promocion.condiciones">
                                <small>{{ item.promocion.condiciones }}</small>
                            </div>
                            <div class="text-center" v-lang.validoHasta></div>
                            <div class="text-center lead">
                                <strong>{{ item.fecha_vencimiento | moment("DD/MM/YYYY HH:mm") }}</strong>
                            </div>
                            <div class="text-center redeem-buttons">
                                <button class="btn btn-primary btn-full" @click="onRedeemClick(item)">{{ translate('canjearBeneficio') }}</button>
                            </div>
                        </div>
                    </div>
                    <div id='form' class='form row' v-show="usedTarjetas.length > 0 || expiredTarjetas.length > 0">
                        <h1 v-show="allTarjetas.length == 0">
                            {{ this.translate('noPromotions') }}
                        </h1>
                        <h1 v-show="usedTarjetas.length > 0">
                            {{ this.translate('takenPromotions') }}
                        </h1>
                        <div v-for="item in usedTarjetas" class="promotion-item" v-bind:key="item.uuid">
                            <PromotionItem :item="item" />
                            <hr />
                        </div>
                        <h1 v-show="expiredTarjetas.length > 0">
                            {{ this.translate('noTakenPromotions') }}
                        </h1>
                        <div v-for="item in expiredTarjetas" class="promotion-item" v-bind:key="item.uuid">
                            <PromotionItem :item="item" />
                            <hr />
                        </div>
                    </div>
                    <div v-if="!(usedTarjetas.length > 0 || expiredTarjetas.length > 0 || activeTarjetas.length > 0)">
                        <div class="form" v-lang.sinPromociones>
                            Aún no has conseguido ninguna promoción.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <RedeemBenefit
            :visible="redeemVisible"
            :tarjeta="selectedTarjeta"
            @close="onRedeemClose"
            @redeem="onRedeemSubmit"
        />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PromotionItem from '../elements/PromotionItem';
import RedeemBenefit from '../elements/RedeemBenefit';
import dialogs from '@/services/dialogs';
let defaultProfilePic = require('@/assets/img/default.jpg');

export default {
    name: 'promotions',
    data () {
        return {
            localTarjetas: [],
            redeemVisible: false,
            selectedTarjeta: null
        };
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            settings: 'company/config'
        }),
        allTarjetas () {
            if (this.localTarjetas && this.localTarjetas.length) {
                return this.localTarjetas;
            }
            if (this.user && this.user.tarjetas_beneficio && this.user.tarjetas_beneficio.length) {
                return this.user.tarjetas_beneficio;
            }
            return [];
        },
        expiredTarjetas () {
            return this.allTarjetas.filter(t => t.estado === 'vencida' || t.expirada);
        },
        usedTarjetas () {
            return this.allTarjetas.filter(t => t.estado === 'utilizada' || t.utilizada);
        },
        activeTarjetas () {
            return this.allTarjetas.filter(t => t.estado === 'activa' && !t.expirada && !t.utilizada);
        }
    },
    mounted () {
        this.language = this.$getLang();
        this.loadTarjetas();
    },
    methods: {
        ...mapActions({
            getMisTarjetasBeneficio: 'passenger/getMisTarjetasBeneficio',
            canjearTarjetaBeneficio: 'passenger/canjearTarjetaBeneficio'
        }),
        loadTarjetas () {
            this.getMisTarjetasBeneficio().then((tarjetas) => {
                this.localTarjetas = tarjetas;
            });
        },
        profilePic (item) {
            return item.promocion.anunciante.logo ? this.$profile(item.promocion.anunciante.logo) : defaultProfilePic;
        },
        onRedeemClick (item) {
            this.selectedTarjeta = item;
            this.redeemVisible = true;
        },
        onRedeemClose () {
            this.redeemVisible = false;
            this.selectedTarjeta = null;
        },
        onRedeemSubmit (payload) {
            if (!this.selectedTarjeta) {
                return;
            }
            let data = {
                tarjeta_id: this.selectedTarjeta.id,
                qr_token: payload.qr_token,
                codigo: payload.codigo
            };
            this.canjearTarjetaBeneficio(data).then(() => {
                this.onRedeemClose();
                this.loadTarjetas();
                dialogs.message(this.translate('canjeadoConExito'), { duration: 10, estado: 'success' });
            }).catch((err) => {
                let code = err && err.data;
                if (code === 'invalid_code' || code === 'invalid_merchant') {
                    dialogs.message(this.translate('secretEquivocado'), { duration: 10, estado: 'error' });
                } else if (code === 'card_expired') {
                    dialogs.message(this.translate('tarjetaVencida'), { duration: 10, estado: 'error' });
                } else if (code === 'card_already_used') {
                    dialogs.message(this.translate('tarjetaYaUtilizada'), { duration: 10, estado: 'error' });
                } else {
                    dialogs.message(this.translate('canjeadoConError'), { duration: 10, estado: 'error' });
                }
            });
        }
    },
    components: {
        PromotionItem,
        RedeemBenefit
    }
};
</script>

<style scoped>
    .container-fluid {
        background: var(--form-background-color);
        min-height: 100%;
    }
    .col-container {
        padding: 0 .4em;
    }
   .form {
        padding: 1.4em;
        background-color: white;
        box-shadow: 0px 1px 5px 3px rgba(0, 0, 0, .1);
        margin-top: 1.2em;
        margin-bottom: 1.2em;
    }
    p {
        margin-top: 0;
    }
    h1 {
        font-weight: normal;
        margin-bottom: 1em;
    }
    .promotion-item {
        margin-bottom: 1.5em;
        font-size: 0.8rem;
    }
    .promotion-item hr {
        border-color: var(--text-color);
    }
    .logo-anunciante {
        max-width: 150px;
        display: block;
        margin: 0 auto;
    }
    .discount-offer {
        background: var(--main-color);
        color: white;
        font-size: 42px;
        display: inline-block;
        border-radius: 120px;
        margin: 12px auto;
        width: 120px;
        height: 120px;
        line-height: 120px;
        font-weight: bold;
    }
    .no-mb {
        margin-bottom: 0;
    }
    .lead strong {
        font-size: 1.1em;
    }
    .redeem-buttons {
        margin-top: 1em;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Promotions.vue